import React from 'react';

interface IconProps {
  size?: number;
  style?: React.CSSProperties;
}

export function EyeIcon({ style = {} }: IconProps) {
  return (
    <svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

export function EyeOffIcon({ style = {} }: IconProps) {
  return (
    <svg
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M17.94 17.94A10.94 10.94 0 0 1 12 19c-7 0-11-7-11-7a21.07 21.07 0 0 1 5.06-7.06" />
      <path d="M1 1l22 22" />
      <path d="M9.53 9.53A3 3 0 0 0 12 15a3 3 0 0 0 2.47-5.47" />
      <path d="M12 3c7 0 11 7 11 7a20.94 20.94 0 0 1-4.88 6.26" />
    </svg>
  );
}

// Additional icons for Personal Cabinet
const User: React.FC<IconProps> = ({ size = 24, style = {} }) => (
  <svg width={size} height={size} style={style} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
    <circle cx="12" cy="7" r="4"/>
  </svg>
);

const Building: React.FC<IconProps> = ({ size = 24, style = {} }) => (
  <svg width={size} height={size} style={style} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
    <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"/>
    <path d="M6 12h12"/>
    <path d="M6 8h12"/>
    <path d="M6 16h12"/>
  </svg>
);

const Package: React.FC<IconProps> = ({ size = 24, style = {} }) => (
  <svg width={size} height={size} style={style} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
    <path d="M16.5 9.4 7.55 4.24"/>
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
    <polyline points="3.29,7 12,12 20.71,7"/>
    <line x1="12" y1="22" x2="12" y2="12"/>
  </svg>
);

const Tag: React.FC<IconProps> = ({ size = 24, style = {} }) => (
  <svg width={size} height={size} style={style} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
    <path d="M12 2H2v10l9.29 9.29c.94.94 2.48.94 3.42 0l6.58-6.58c.94-.94.94-2.48 0-3.42L12 2Z"/>
    <path d="M7 7h.01"/>
  </svg>
);

const Edit: React.FC<IconProps> = ({ size = 24, style = {} }) => (
  <svg width={size} height={size} style={style} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
    <path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4Z"/>
  </svg>
);

const Upload: React.FC<IconProps> = ({ size = 24, style = {} }) => (
  <svg width={size} height={size} style={style} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
    <polyline points="7,10 12,5 17,10"/>
    <line x1="12" y1="5" x2="12" y2="15"/>
  </svg>
);

const Plus: React.FC<IconProps> = ({ size = 24, style = {} }) => (
  <svg width={size} height={size} style={style} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
    <path d="M5 12h14"/>
    <path d="M12 5v14"/>
  </svg>
);

const Check: React.FC<IconProps> = ({ size = 24, style = {} }) => (
  <svg width={size} height={size} style={style} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
    <path d="M20 6 9 17l-5-5"/>
  </svg>
);

const X: React.FC<IconProps> = ({ size = 24, style = {} }) => (
  <svg width={size} height={size} style={style} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
    <path d="M18 6 6 18"/>
    <path d="M6 6l12 12"/>
  </svg>
);

const Trash: React.FC<IconProps> = ({ size = 24, style = {} }) => (
  <svg width={size} height={size} style={style} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
    <path d="M3 6h18"/>
    <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/>
    <path d="M8 6V4c0-1 1-2 2-2h4c-1 0 2 1 2 2v2"/>
  </svg>
);

const Lock: React.FC<IconProps> = ({ size = 24, style = {} }) => (
  <svg width={size} height={size} style={style} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
    <rect width="18" height="11" x="3" y="11" rx="2" ry="2"/>
    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
  </svg>
);

const Mail: React.FC<IconProps> = ({ size = 24, style = {} }) => (
  <svg width={size} height={size} style={style} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
    <rect width="20" height="16" x="2" y="4" rx="2"/>
    <path d="m22 7-10 6L2 7"/>
  </svg>
);

export const Icons = {
  User,
  Building,
  Package,
  Tag,
  Edit,
  Upload,
  Plus,
  Check,
  X,
  Trash,
  Lock,
  Mail,
  Eye: EyeIcon,
  EyeOff: EyeOffIcon
};
